/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './quote';
import './quote-source-bottom-copy';
import './quote-source-copy';
import './quote-source-heading';
import './quote-link-with-icon';
